export default (_component => function (event) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  return function () {
    // Uncomment to get trace logging on event handling
    // console.log(`${_component}: ${event}`);
    handler(...arguments);
  };
});